import React, { useState } from 'react';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function returnPath(location) {
    const from = location.state?.from;
    const pathname = from?.pathname;
    if (typeof pathname !== 'string' || !pathname.startsWith('/') || pathname.startsWith('//')) {
        return '/devices';
    }
    return `${pathname}${from.search || ''}${from.hash || ''}`;
}

export default function LoginPage() {
    const { login } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSubmitting(true);
        try {
            await login(username, password);
            setPassword('');
            navigate(returnPath(location), { replace: true });
        } catch {
            setError('Invalid username or password.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Container className="brand-page mt-5" style={{ maxWidth: 480 }}>
            <h1>Sign in</h1>
            <p>Sign in with an account provided by a NOStraTV administrator.</p>
            {error && <Alert variant="danger" role="alert">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="website-username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        autoComplete="username"
                        required
                        value={username}
                        onChange={(event) => setUsername(event.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="website-password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        autoComplete="current-password"
                        required
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                    />
                </Form.Group>
                <Button type="submit" disabled={submitting}>
                    {submitting ? 'Signing in…' : 'Sign in'}
                </Button>
            </Form>
        </Container>
    );
}
